let modelViewerLoaded = false;

export const loadModelViewer = async () => {
  if (modelViewerLoaded || window.customElements.get('model-viewer')) {
    return true;
  }

  try {
    await import('@google/model-viewer/dist/model-viewer.min.js');
    modelViewerLoaded = true;
    return true;
  } catch (error) {
    console.error('Error loading model-viewer:', error);
    return false;
  }
};